/***** RECENTLY VIEWED PRODUCTS *****/
document.addEventListener('DOMContentLoaded', function () {
  const productHandle = window?.meta?.product?.handle;
  if (!productHandle) return;

  let viewed = JSON.parse(localStorage.getItem('recent_products') || '[]');

  // Remove if already exists
  viewed = viewed.filter(h => h !== productHandle);

  // Add to front
  viewed.unshift(productHandle);

  // Limit to 12 (same as max setting)
  viewed = viewed.slice(0, 12);

  localStorage.setItem('recent_products', JSON.stringify(viewed));
});
